import React, { useEffect, useState } from "react";
import { Badge, NumberInput, Text, ActionIcon } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { getOverdueObligations } from "../apis/obligationApi";
import { getComplianceBadgeColor, formatDatetoISO } from "./utilities";
import UniversalTable from "../componenets/Common/UniversalTable";

const OverDueCompliance = () => {
  const navigate = useNavigate();
  const [days, setDays] = useState(15);
  const [configs, setConfigs] = useState({
    loading: true,
    overdue: [],
    count: 0,
  });

  useEffect(() => {
    const load = async () => {
      setConfigs((prev) => ({ ...prev, loading: true }));
      try {
        const response = await getOverdueObligations({ days });
        setConfigs({
          loading: false,
          overdue: response?.overdue || [],
          count: response?.count || 0,
        });
      } catch (error) {
        setConfigs({ loading: false, overdue: [], count: 0 });
      }
    };
    if (days) load();
  }, [days]);

  const daysOverdue = (duedate) =>
    Math.floor((new Date() - new Date(duedate)) / (1000 * 60 * 60 * 24));

  return (
    <div className="p-4">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <Text className="font-semibold text-3xl">Overdue Obligations</Text>
        <div className="flex items-center gap-3">
          <Text size="sm" color="dimmed">
            Overdue in the last
          </Text>
          <NumberInput
            value={days}
            onChange={(value) => setDays(value || 15)}
            min={1}
            max={365}
            w={90}
          />
          <Text size="sm" color="dimmed">
            days ({configs.count} found)
          </Text>
        </div>
      </div>

      <UniversalTable
        headers={[
          {
            label: "Title",
            render: (row) => <Text size="sm">{row.title}</Text>,
          },
          {
            label: "Clause",
            align: "center",
            render: (row) => <Text size="sm">{row.clNo || "-"}</Text>,
          },
          {
            label: "Due Date",
            align: "center",
            render: (row) => <Text size="sm">{formatDatetoISO(row.duedate)}</Text>,
          },
          {
            label: "Days Overdue",
            align: "center",
            render: (row) => <Text size="sm">{daysOverdue(row.duedate)}</Text>,
          },
          {
            label: "Counter Party",
            render: (row) => <Text size="sm">{row.connectedParty || "-"}</Text>,
          },
          {
            label: "Department",
            align: "center",
            render: (row) => <Text size="sm">{row.dept?.name || "-"}</Text>,
          },
          {
            label: "Assignee",
            align: "center",
            render: (row) => <Text size="sm">{row.assignTo?.name || "Unassigned"}</Text>,
          },
          {
            label: "Status",
            align: "center",
            render: (row) => (
              <Badge color={getComplianceBadgeColor(row.compliant) || "gray"} variant="light">
                {row.compliant || "Not Set"}
              </Badge>
            ),
          },
          {
            label: "View",
            align: "center",
            render: (row) => (
              <ActionIcon onClick={() => navigate(`/viewobligation/${row.id}`)}>
                <IconEye size={20} color="#1b6f8d" />
              </ActionIcon>
            ),
          },
        ]}
        data={configs.overdue}
        loading={configs.loading}
        emptyMessage={`No obligations became overdue in the last ${days} days.`}
      />
    </div>
  );
};

export default OverDueCompliance;
